import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      CHOOSE_DISHES: "Velg middager",
      NO_DELIVERIES_BEFORE_START_WEEK: "Du kan ikke bestille før startuke",
    },

    se: {
      CHOOSE_DISHES: "Välj middagar",
      NO_DELIVERIES_BEFORE_START_WEEK: "Du kan inte beställa innan startvecka",
    },

    dk: {
      CHOOSE_DISHES: "Vælg retter",
      NO_DELIVERIES_BEFORE_START_WEEK: "Du kan ikke bestille før startuge",
    },
  } as const
)[language];
